import { Pile } from "~/utils";
import { EffectExecution } from "./EffectExecutionManager2";
import { Game } from "./Game";
import { Meaple, TurnPhase } from "./constant";

let game: Game | null = null;

export const dummyGame = (): Game => {
  if (!game) {
    game = new Game({
      players: [],
      currentPlayerIndex: 0,
      firstPlayerIndex: 0,
      actionSlots: [],
      shop: Pile.empty(),
      shopDeck: Pile.empty(),
      battleDiscard: Pile.empty(),
      battleDeck: Pile.empty(),
      turnPhase: TurnPhase.Play,
      mentatOnSlotOpt: undefined,
      intrigueDeck: Pile.empty(),
      intrigueDiscard: Pile.empty(),
      effectExecution: EffectExecution.new(),
      skipCleanMentat: false,
      // @ts-ignore
      TSMFPile: null,
      // @ts-ignore
      ArrakisLiaisonPile: null,
      infoEvents: [],
      techTiles: [],
      trashedTechTiles: Pile.empty(),
      startTurnSlotWithDreadnought: [],
    });
  }
  return game;
};
